import styled from 'styled-components'
import { black, darkOrange, textMuted, warmTint } from '@/theme/colors'
import { radii } from '@/theme/tokens'
import { text } from '@/theme/typography'

export const FieldValue = styled.span`
	display: flex;
	align-items: center;
	gap: 12px;
	min-width: 0;
	${text.bodySm}
	color: ${black};
`

/** The category's glyph on the bento chips' warm tile; the catch-all Other reads quieter. */
export const CategoryTile = styled.span<{ $muted: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: 28px;
	height: 28px;
	border-radius: ${radii.small};
	background: ${warmTint};
	color: ${({ $muted }) => ($muted ? textMuted : darkOrange)};
`

export const SheetList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`

export const RowName = styled.span`
	flex: 1;
	min-width: 0;
	${text.label}
	color: ${black};
`

export const RowCheck = styled.span`
	display: flex;
	color: ${darkOrange};
`
